exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* purgecss start ignore */\n.privacy-label[data-v-3691cf18] {\n  color: #d8d8d8 !important;\n  font-size: 10px !important;\n  margin: 0 0 0 5px !important;\n  position: relative !important;\n  text-transform: capitalize !important;\n  background-color: transparent !important;\n}\n.privacy-label[data-v-3691cf18]:hover {\n  background-color: transparent !important;\n}\n.privacy-wrapper[data-v-3691cf18] {\n  bottom: 4px !important;\n}\n.vue-js-switch[data-v-3691cf18] {\n  font-size: 1rem !important;\n}\n\n/* purgecss end ignore */\n\n", ""]);

// exports
